module.exports = __webpack_public_path__ + "images/for_company_page/tc-techcrunch_726d07fcd9938de20fe115bed65c0d57.png";